import ToggleableSection from 'components/ToggleableSection'
import { withContext } from '../Context'
import { AcademicFocusSelector, IAcademicFocusSelector } from '../AcademicFocusSelector'
import CareerSelector from '../CareerSelector'

export const FocusAndCareerSelector = ({ criteria = 'OneOf', segment, onChange }: IAcademicFocusSelector) => {
  return (
    <ToggleableSection
      title="Academic & Career Interests"
      info="Broad categories of academic disciplines and career clusters"
    >
      <AcademicFocusSelector criteria={criteria} segment={segment} onChange={onChange} />
      <CareerSelector />
    </ToggleableSection>
  )
}

export default withContext(FocusAndCareerSelector)
